import { render, staticRenderFns } from "./InternacionReciente.vue?vue&type=template&id=9b8a3aa0&scoped=true&lang=pug&"
import script from "./InternacionReciente.vue?vue&type=script&lang=js&"
export * from "./InternacionReciente.vue?vue&type=script&lang=js&"
import style0 from "./InternacionReciente.vue?vue&type=style&index=0&id=9b8a3aa0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a3aa0",
  null
  
)

export default component.exports